import jwt_decode from 'jwt-decode';
import { ENTRYPOINT } from './config/entrypoint';

const authenticationTokenUri = `${ENTRYPOINT}/login_check`;

const authProvider = {
  login: ({ username, password }) => {
    const request = new Request(authenticationTokenUri, {
      method: 'POST',
      body: JSON.stringify({ email: username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then((auth) => {
        let _token = jwt_decode(auth.token);
        console.log(auth);
        console.log(_token);
        // if(_token.roles.indexOf('ROLE_SUPER_ADMIN') !== -1) {
        //   localStorage.setItem('auth', auth.token);
        //   // window.location.replace('/');
        // } else {
        //   localStorage.removeItem('auth');
        //   window.location.replace('/login');
        // }
        localStorage.setItem('auth', auth.token);
      })
      .catch(() => {
        throw new Error('Network error');
      });
  },
  checkAuth: () => {
    return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject();
  },
  getIdentity: () => {
    return jwt_decode(localStorage.getItem('auth'));
  },
  getPermissions: () => {
    const user = jwt_decode(localStorage.getItem('auth'));

    if (user === null) {
      Promise.reject();
    }

    const roles = user.roles;
    return roles ? Promise.resolve(roles) : Promise.reject();
  },
  checkError: (error) => {
    const status = error.status;

    if (status === 401) {
      localStorage.removeItem('auth');
      return Promise.reject();
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  logout: () => {
    localStorage.removeItem('auth');
    return Promise.resolve();
  },
};

export default authProvider;
